import {createApp} from 'vue'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import smoothScroll from './directives/smoothScroll';

import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.fake-dark-selector', // trying to also force a non-usage of the dark mode
        },
    }
}).directive('smooth-scroll', smoothScroll).mount('#app')
